import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SensorTimelineComponentPage } from './sensor-timeline-component.page';

const routes: Routes = [
  {
    path: '',
    component: SensorTimelineComponentPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SensorTimelineComponentPageRoutingModule {}
